import { put, call } from 'redux-saga/effects';
import {
  getSingleErrorDataString,
  getDefaultMessage
} from '@epi-helpers/ErrorDataHelper';
import { lowerFirst } from 'lodash';
import { ErrorSeverity } from '@epi-constants/errorSeverity';
import * as overlaysActions from '../actions/overlays';

interface ApiError {
  content?: {
    errors?: Array<{
      value?: string;
      severity: string;
      data?: any;
    }>;
  };
}

export function* Notify(
  message: string,
  type: string = 'success',
  translated: boolean = false
) {
  yield put(
    overlaysActions.showNotification(
      {
        message,
        translated
      },
      type
    )
  );
}

export function* NotifyApiErrors(
  apiError: ApiError,
  translated: boolean = true
) {
  if (!apiError?.content?.errors) {
    yield call(Notify, getDefaultMessage(), lowerFirst(ErrorSeverity.Error));
  } else {
    for (const error of apiError.content.errors) {
      yield call(
        Notify,
        error.value || getSingleErrorDataString(error),
        lowerFirst(error.severity),
        translated
      );
    }
  }
}
